import React, { useCallback } from 'react';
import { translate } from '@utils/i18n';
import { Controller, useFormContext } from 'react-hook-form';
import TextInput from '@components/TextInput/TextInput';
import { GenericEventType } from '@features/Calendar/constants';
function SiteVisitInformation() {
    const namespace = 'features.modals.new_generic_event_modal.basic_information_section.site_visit_information';
    const { control } = useFormContext();
    const validateAddress = useCallback((value, { eventType }) => {
        if (eventType === GenericEventType.Site_visit && !value)
            return false;
        return true;
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Controller, { name: "address", control: control, rules: { validate: validateAddress }, render: ({ field }) => (React.createElement(TextInput, { id: "address", value: field.value, name: field.name, onChange: field.onChange, label: translate('visit_address', { namespace }), required: true })) }),
        React.createElement("div", { className: 'equalChildren' },
            React.createElement(Controller, { name: "contactName", control: control, render: ({ field }) => (React.createElement(TextInput, { id: "contactName", value: field.value, name: field.name, onChange: field.onChange, label: translate('contact_name', { namespace }) })) }),
            React.createElement(Controller, { name: "contactPhone", control: control, render: ({ field }) => (React.createElement(TextInput, { id: "contactPhone", value: field.value, name: field.name, onChange: field.onChange, label: translate('contact_phone', { namespace }) })) }))));
}
export default SiteVisitInformation;
